module.exports = __webpack_public_path__ + "img/7.669d7229.png";